import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardActions,
  Tabs,
  Tab,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Alert,
  Breadcrumbs,
  Link,
  Paper,
  Tooltip,
  ToggleButtonGroup,
  ToggleButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondary,
  ListItemButton,
  Chip,
  InputAdornment,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import {
  Add as AddIcon,
  MoreVert as MoreVertIcon,
  Delete as DeleteIcon,
  Share as ShareIcon,
  Visibility as VisibilityIcon,
  CloudUpload as CloudUploadIcon,
  CreateNewFolder as CreateNewFolderIcon,
  Folder as FolderIcon,
  Edit as EditIcon,
  DriveFileMove as DriveFileMoveIcon,
  GridView as GridViewIcon,
  ViewList as ViewListIcon,
  Search as SearchIcon,
  Description as DescriptionIcon,
  TableChart as TableChartIcon,
  Image as ImageIcon,
  PictureAsPdf as PdfIcon,
  InsertDriveFile as FileIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  Public as PublicIcon,
  Lock as LockIcon,
  Home as HomeIcon,
  Label as LabelIcon,
} from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import { fileService, groupService, folderService } from "../services/api";
import { useAuth } from "../contexts/AuthContext";
import SharePermissionsDialog from "../components/SharePermissionsDialog";
import EditFolderTagsDialog from "../components/EditFolderTagsDialog";
import TagChip from "../components/TagChip";

const Dashboard = () => {
  const [files, setFiles] = useState([]);
  const [folders, setFolders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [renameFileDialogOpen, setRenameFileDialogOpen] = useState(false);
  const [newFileName, setNewFileName] = useState("");
  const [blankMenuAnchor, setBlankMenuAnchor] = useState(null);
  const [blankDialogOpen, setBlankDialogOpen] = useState(false);
  const [blankType, setBlankType] = useState(null);
  const [blankName, setBlankName] = useState("");
  const [blankLoading, setBlankLoading] = useState(false);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [createFolderDialogOpen, setCreateFolderDialogOpen] = useState(false);
  const [renameFolderDialogOpen, setRenameFolderDialogOpen] = useState(false);
  const [moveFolderDialogOpen, setMoveFolderDialogOpen] = useState(false);
  const [moveFileDialogOpen, setMoveFileDialogOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [selectedTargetFolder, setSelectedTargetFolder] = useState(null);
  const [showContent, setShowContent] = useState(true);
  const [viewMode, setViewMode] = useState("list");
  const [sortField, setSortField] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isGlobalSearch, setIsGlobalSearch] = useState(false);
  const [accessLevel, setAccessLevel] = useState("READ");
  const [isPublic, setIsPublic] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [folderAnchorEl, setFolderAnchorEl] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState("");
  const [newFolderName, setNewFolderName] = useState("");
  const [currentFolderId, setCurrentFolderId] = useState(null);
  const [folderPath, setFolderPath] = useState([{ id: null, name: "Raiz" }]);
  const [targetFolderId, setTargetFolderId] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [shareFolderDialogOpen, setShareFolderDialogOpen] = useState(false);
  const [folderTagsDialogOpen, setFolderTagsDialogOpen] = useState(false);
  const [folderTree, setFolderTree] = useState([]);
  const [currentTreePath, setCurrentTreePath] = useState([]);
  const [selectedTreeFolder, setSelectedTreeFolder] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [groups, setGroups] = useState([]);

  const location = useLocation();
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const isAdmin =
    currentUser?.role === "ADMIN" || currentUser?.role === "admin";
  console.log("Detalhes do usuário atual:", currentUser);
  console.log("É admin?", isAdmin);

  const { getRootProps, getInputProps, acceptedFiles, open } = useDropzone({
    multiple: true,
    noClick: false,
    noKeyboard: false,
    accept: {
      "image/*": [".png", ".jpg", ".jpeg", ".gif"],
      "application/pdf": [".pdf"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
      "text/plain": [".txt"],
      "application/zip": [".zip"],
      "application/x-zip-compressed": [".zip"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
      "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"],
      "application/vnd.ms-excel.sheet.binary.macroEnabled.12": [".xlsb"],
      "application/vnd.ms-excel.template.macroEnabled.12": [".xltm"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [".xltx"],
      "application/vnd.ms-excel.template": [".xlt"],
    },
  });

  // Verifica se há um currentFolderId no state da navegação
  useEffect(() => {
    // Se tiver um currentFolderId no state, usá-lo
    if (location.state?.currentFolderId) {
      setCurrentFolderId(location.state.currentFolderId);
      // Limpar o state para evitar problemas com navegação futura
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        setLoading(true);
        setError("");

        console.log("Carregando dados para a pasta:", currentFolderId);

        // Se estiver na raiz, carrega todos os arquivos e pastas
        if (!currentFolderId) {
          const filesResponse = await fileService.getFiles();
          if (cancelled) return;
          setFiles(filesResponse.data || []);

          const foldersResponse = await folderService.getFolders();
          if (cancelled) return;
          setFolders(foldersResponse.data || []);

          const groupsResponse = await groupService.getGroups();
          if (cancelled) return;
          setGroups(groupsResponse.data || []);

          console.log("Resetando para o caminho raiz");
          setFolderPath([{ id: null, name: "Raiz" }]);
        } else {
          try {
            const folderResponse = await folderService.getFolder(
              currentFolderId
            );
            if (cancelled) return;

            if (folderResponse.data) {
              const filesResponse = await fileService.getFiles(currentFolderId);
              if (cancelled) return;
              setFiles(filesResponse.data || []);

              const foldersResponse = await folderService.getFolders(
                currentFolderId
              );
              if (cancelled) return;
              setFolders(foldersResponse.data || []);

              const groupsResponse = await groupService.getGroups();
              if (cancelled) return;
              setGroups(groupsResponse.data || []);

              console.log("Buscando detalhes da pasta:", currentFolderId);
              const newPath = await buildFolderPathIterative(currentFolderId);
              if (cancelled) return;
              console.log("Caminho da pasta atualizado:", newPath);
              setFolderPath(newPath);
            }
          } catch (err) {
            if (cancelled) return;
            console.error("Erro ao verificar acesso à pasta:", err);
            setError(
              "Você não tem permissão para acessar esta pasta. Entre em contato com um administrador."
            );
            setCurrentFolderId(null);
            setFolderPath([{ id: null, name: "Raiz" }]);
          }
        }
      } catch (err) {
        if (cancelled) return;
        setError("Falha ao carregar dados");
        console.error("Erro ao carregar dados:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [currentFolderId]);

  const handleMenuOpen = (event, file) => {
    setAnchorEl(event.currentTarget);
    setSelectedFile(file);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleFolderMenuOpen = (event, folder) => {
    setFolderAnchorEl(event.currentTarget);
    setSelectedFolder(folder);
  };

  const handleFolderMenuClose = () => {
    setFolderAnchorEl(null);
  };

  const handleFileClick = async (file) => {
    try {
      console.log("Verificando acesso ao arquivo:", file.id, file.name);

      // Verifica se o usuário tem acesso ao arquivo
      const response = await fileService.getFile(file.id);

      if (response.data) {
        console.log("Acesso permitido ao arquivo:", file.id, file.name);
        // Passa o ID da pasta atual para permitir o retorno
        navigate(`/files/${file.id}`, { state: { folderId: currentFolderId } });
      }
    } catch (err) {
      console.error("Erro ao verificar acesso ao arquivo:", err);
      setError(
        "Você não tem permissão para acessar este arquivo. Entre em contato com um administrador."
      );
    }
  };

  const handleFolderClick = async (folder) => {
    try {
      console.log("Verificando acesso à pasta:", folder.id, folder.name);

      // Se for a pasta raiz, permite o acesso
      if (!folder.id) {
        setCurrentFolderId(null);
        // Clear global search when navigating
        setIsGlobalSearch(false);
        setSearchTerm("");
        setSearchResults([]);
        return;
      }

      // Verifica se o usuário tem acesso à pasta
      const response = await folderService.getFolder(folder.id);

      if (response.data) {
        console.log("Acesso permitido à pasta:", folder.id, folder.name);
        setCurrentFolderId(folder.id);
        // Clear global search when navigating to specific folder
        setIsGlobalSearch(false);
        setSearchTerm("");
        setSearchResults([]);
      }
    } catch (err) {
      console.error("Erro ao verificar acesso à pasta:", err);
      setError(
        "Você não tem permissão para acessar esta pasta. Entre em contato com um administrador."
      );
    }
  };

  const handleBreadcrumbClick = (folderId) => {
    console.log("Navegando pelo breadcrumb para a pasta:", folderId);
    setCurrentFolderId(folderId);
    // Clear global search when navigating via breadcrumb
    setIsGlobalSearch(false);
    setSearchTerm("");
    setSearchResults([]);
  };

  const handleUploadDialogOpen = () => {
    setUploadDialogOpen(true);
  };

  const handleRenameFileDialogOpen = () => {
    setNewFileName(selectedFile?.name || "");
    setRenameFileDialogOpen(true);
    handleMenuClose();
  };

  const handleRenameFileDialogClose = () => {
    setRenameFileDialogOpen(false);
    setNewFileName("");
  };

  const handleRenameFile = async () => {
    if (!selectedFile || !newFileName.trim() || newFileName === selectedFile.name) {
      handleRenameFileDialogClose();
      return;
    }
    try {
      const res = await fileService.updateFile(selectedFile.id, {
        name: newFileName.trim(),
      });
      setFiles((prev) =>
        prev.map((f) => (f.id === selectedFile.id ? { ...f, ...res.data } : f))
      );
      handleRenameFileDialogClose();
    } catch (err) {
      console.error("Erro ao renomear arquivo:", err);
      setError(err.response?.data?.error || "Falha ao renomear arquivo");
    }
  };

  const handleBlankMenuOpen = (e) => setBlankMenuAnchor(e.currentTarget);
  const handleBlankMenuClose = () => setBlankMenuAnchor(null);

  const handleBlankTypeSelect = (type) => {
    setBlankType(type);
    setBlankName("");
    setBlankMenuAnchor(null);
    setBlankDialogOpen(true);
  };

  const handleBlankCreate = async () => {
    if (!blankName.trim()) return;
    setBlankLoading(true);
    try {
      const res = await fileService.createBlank({
        name: blankName.trim(),
        type: blankType,
        folderId: currentFolderId || null,
      });
      setBlankDialogOpen(false);
      window.open(`/files/${res.data.id}/edit`, "_blank");
    } catch (err) {
      console.error("Erro ao criar documento:", err);
      setError(err.response?.data?.error || "Erro ao criar documento");
    } finally {
      setBlankLoading(false);
    }
  };

  const handleUploadDialogClose = () => {
    setUploadDialogOpen(false);
    setUploadProgress(0);
    setUploadError("");
  };

  const handleShareDialogOpen = () => {
    setShareDialogOpen(true);
    handleMenuClose();
  };

  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
  };

  const handleDeleteDialogOpen = () => {
    setDeleteDialogOpen(true);
    handleMenuClose();
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleCreateFolderDialogOpen = () => {
    setCreateFolderDialogOpen(true);
    setNewFolderName("");
  };

  const handleCreateFolderDialogClose = () => {
    setCreateFolderDialogOpen(false);
  };

  const handleRenameFolderDialogOpen = () => {
    setRenameFolderDialogOpen(true);
    setNewFolderName(selectedFolder.name);
    handleFolderMenuClose();
  };

  const handleRenameFolderDialogClose = () => {
    setRenameFolderDialogOpen(false);
  };

  const handleMoveFolderDialogOpen = () => {
    setMoveFolderDialogOpen(true);
    setCurrentTreePath([]);
    setSelectedTreeFolder(null);
    loadFolderTree();
    handleFolderMenuClose();
  };

  const handleMoveFolderDialogClose = () => {
    setMoveFolderDialogOpen(false);
    setCurrentTreePath([]);
    setSelectedTreeFolder(null);
    setFolderTree([]);
  };

  const handleMoveFileDialogOpen = () => {
    setMoveFileDialogOpen(true);
    setCurrentTreePath([]);
    setSelectedTreeFolder(null);
    loadFolderTree();
    handleMenuClose();
  };

  const handleMoveFileDialogClose = () => {
    setMoveFileDialogOpen(false);
    setCurrentTreePath([]);
    setSelectedTreeFolder(null);
    setFolderTree([]);
  };

  const handleCreateFolder = async () => {
    if (!newFolderName.trim()) {
      return;
    }

    try {
      const folderData = {
        name: newFolderName.trim(),
        parentId: currentFolderId,
        isPublic: false,
      };

      const response = await folderService.createFolder(folderData);

      // Update folders list
      setFolders((prevFolders) => [response.data, ...prevFolders]);

      handleCreateFolderDialogClose();
    } catch (err) {
      console.error("Erro ao criar pasta:", err);
      setError("Falha ao criar pasta");
    }
  };

  const handleRenameFolder = async () => {
    if (!newFolderName.trim() || !selectedFolder) {
      return;
    }

    try {
      const folderData = {
        name: newFolderName.trim(),
      };

      const response = await folderService.updateFolder(
        selectedFolder.id,
        folderData
      );

      // Update folders list
      setFolders((prevFolders) =>
        prevFolders.map((folder) =>
          folder.id === selectedFolder.id ? response.data : folder
        )
      );

      handleRenameFolderDialogClose();
    } catch (err) {
      console.error("Erro ao renomear pasta:", err);
      setError("Falha ao renomear pasta");
    }
  };

  const handleMoveFolder = async () => {
    if (!selectedFolder) return;
    const destId = currentTreePath[currentTreePath.length - 1]?.id || null;

    if (destId === selectedFolder.id) {
      setError("Não é possível mover uma pasta para dentro dela mesma");
      return;
    }

    try {
      await folderService.moveFolder(selectedFolder.id, destId);

      setFolders((prevFolders) =>
        prevFolders.filter((folder) => folder.id !== selectedFolder.id)
      );

      handleMoveFolderDialogClose();
      setCurrentTreePath([]);
      setSelectedTreeFolder(null);
      setFolderTree([]);
    } catch (err) {
      console.error("Erro ao mover pasta:", err);
      setError(err.response?.data?.error || "Falha ao mover pasta");
    }
  };

  const handleDeleteFolder = async () => {
    if (!selectedFolder) {
      return;
    }

    try {
      await folderService.deleteFolder(selectedFolder.id);

      // Remove folder from list
      setFolders((prevFolders) =>
        prevFolders.filter((folder) => folder.id !== selectedFolder.id)
      );

      handleDeleteDialogClose();
    } catch (err) {
      console.error("Erro ao excluir pasta:", err);
      setError("Falha ao excluir pasta");
    }
  };

  const handleUpload = async () => {
    if (acceptedFiles.length === 0) {
      setUploadError("Por favor, selecione pelo menos um arquivo");
      return;
    }

    setUploadError("");
    const total = acceptedFiles.length;
    const uploaded = [];
    const failed = [];

    for (let i = 0; i < total; i++) {
      const file = acceptedFiles[i];
      setUploadProgress(Math.round(((i) / total) * 100) || 1);

      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);
        formData.append("size", file.size.toString());
        formData.append("contentType", file.type || "application/octet-stream");
        formData.append("isPublic", isPublic.toString());
        if (currentFolderId) {
          formData.append("folderId", currentFolderId);
        }

        const response = await fileService.uploadFile(formData);
        uploaded.push(response.data);
      } catch (err) {
        console.error(`Erro ao enviar ${file.name}:`, err);
        failed.push({ name: file.name, error: err.response?.data?.error || err.message });
      }
    }

    setUploadProgress(100);

    if (uploaded.length > 0) {
      setFiles((prev) => [...uploaded, ...prev]);
    }

    if (failed.length === 0) {
      handleUploadDialogClose();
    } else {
      setUploadError(
        `${uploaded.length} enviado(s), ${failed.length} com erro: ${failed.map((f) => f.name).join(", ")}`
      );
      setUploadProgress(0);
    }
  };


  const handleMoveFile = async () => {
    if (!selectedFile) return;
    const destId = currentTreePath[currentTreePath.length - 1]?.id || null;

    try {
      await fileService.updateFile(selectedFile.id, { folderId: destId });

      setFiles((prevFiles) =>
        prevFiles.filter((file) => file.id !== selectedFile.id)
      );

      handleMoveFileDialogClose();
      setCurrentTreePath([]);
      setSelectedTreeFolder(null);
      setFolderTree([]);
    } catch (err) {
      console.error("Erro ao mover arquivo:", err);
      setError(err.response?.data?.error || "Falha ao mover arquivo");
    }
  };

  const handleShareFolderDialogOpen = () => {
    setShareFolderDialogOpen(true);
    handleFolderMenuClose();
  };

  const handleShareFolderDialogClose = () => {
    setShareFolderDialogOpen(false);
  };

  const handleShareFolder = async () => {
    if (!selectedGroup || !selectedFolder) {
      return;
    }

    try {
      await folderService.shareFolder(selectedFolder.id, {
        groupId: selectedGroup,
        accessLevel: accessLevel,
      });
      handleShareFolderDialogClose();
    } catch (err) {
      console.error("Erro ao compartilhar pasta:", err);
      setError("Falha ao compartilhar pasta");
    }
  };

  // Handle folder tags dialog
  const handleFolderTagsDialogOpen = () => {
    setFolderTagsDialogOpen(true);
    handleFolderMenuClose();
  };

  const handleFolderTagsDialogClose = () => {
    setFolderTagsDialogOpen(false);
  };

  const handleUpdateFolderTags = async () => {
    try {
      // Refresh folders data to get updated tags
      const foldersResponse = await folderService.getFolders(currentFolderId);
      setFolders(foldersResponse.data || []);
      handleFolderTagsDialogClose();
    } catch (err) {
      console.error("Erro ao atualizar dados das pastas:", err);
      setError("Falha ao atualizar dados das pastas");
    }
  };

  // New helper functions for file manager
  const getFileIcon = (mimeType) => {
    if (mimeType.startsWith("image/")) {
      return <ImageIcon color="primary" />;
    } else if (mimeType === "application/pdf") {
      return <PdfIcon sx={{ color: "#f44336" }} />;
    } else if (
      mimeType === "application/msword" ||
      mimeType ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      return <DescriptionIcon sx={{ color: "#2196f3" }} />;
    } else if (mimeType === "text/plain") {
      return <DescriptionIcon sx={{ color: "#757575" }} />;
    } else if (mimeType.includes("zip")) {
      return <FileIcon sx={{ color: "#ffc107" }} />;
    }
    return <FileIcon color="action" />;
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (error) {
      console.error("Erro ao formatar data:", error);
      return dateString;
    }
  };

  const handleSortChange = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const sortItems = (items) => {
    return [...items].sort((a, b) => {
      let aValue = a[sortField];
      let bValue = b[sortField];

      // Handle special cases
      if (
        sortField === "size" &&
        typeof aValue === "number" &&
        typeof bValue === "number"
      ) {
        return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
      }

      // Convert to strings for comparison
      aValue = String(aValue || "").toLowerCase();
      bValue = String(bValue || "").toLowerCase();

      return sortDirection === "asc"
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    });
  };

  const filterItems = (items) => {
    if (!searchTerm || isGlobalSearch) return items;
    return items.filter((item) => {
      const nameMatch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
      
      // Para pastas, também busca nas tags
      if (item.tags && item.tags.length > 0) {
        const tagMatch = item.tags.some((folderTag) => {
          const tag = folderTag.tag || folderTag;
          return tag.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                 (tag.description && tag.description.toLowerCase().includes(searchTerm.toLowerCase()));
        });
        return nameMatch || tagMatch;
      }
      
      return nameMatch;
    });
  };

  // Handle global search
  const handleGlobalSearch = async (term) => {
    if (!term || term.trim().length === 0) {
      setIsGlobalSearch(false);
      setSearchResults([]);
      return;
    }

    if (term.length < 2) {
      setError('Digite pelo menos 2 caracteres para pesquisar');
      return;
    }

    try {
      setIsSearching(true);
      setError(''); // Clear any previous errors
      
      // Clear previous results immediately to avoid confusion
      setSearchResults([]);
      
      const response = await folderService.globalSearch(term.trim());
      
      // Only update results if this is still the current search term
      if (term.trim() === searchTerm.trim()) {
        setIsGlobalSearch(true);
        setSearchResults(response.data);
      }
    } catch (error) {
      console.error('Erro na busca global:', error);
      setError('Erro ao realizar busca global: ' + (error.response?.data?.error || error.message));
      setIsGlobalSearch(false);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  // Handle search term change
  const handleSearchChange = (term) => {
    setSearchTerm(term);
    
    if (term.trim().length === 0) {
      setIsGlobalSearch(false);
      setSearchResults([]);
      setError(''); // Clear any search errors
      return;
    }
  };

  // Handle manual search button click
  const handleSearchClick = () => {
    if (searchTerm.trim().length >= 2) {
      handleGlobalSearch(searchTerm);
    }
  };

  // Handle Enter key press
  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchClick();
    }
  };

  // Render functions for different view modes
  const renderGridView = () => {
    let currentFiles, currentFolders;
    
    if (isGlobalSearch && searchResults.folders && searchResults.files) {
      currentFiles = searchResults.files;
      currentFolders = searchResults.folders;
    } else {
      currentFiles = files;
      currentFolders = folders;
    }

    const filteredFolders = filterItems(currentFolders);
    const filteredFiles = filterItems(currentFiles);

    const sortedFolders = sortItems(filteredFolders);
    const sortedFiles = sortItems(filteredFiles);

    return (
      <Grid container spacing={2}>
        {sortedFolders.map((folder) => (
          <Grid item xs={6} sm={4} md={3} lg={2} key={folder.id}>
            <Paper
              elevation={0}
              sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                overflow: "hidden",
                transition: "all 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                },
              }}
            >
              <Box
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => handleFolderClick(folder)}
              >
                <FolderIcon
                  sx={{ fontSize: 48, color: "primary.main", mb: 1 }}
                />
                <Typography
                  variant="subtitle2"
                  align="center"
                  noWrap
                  sx={{ width: "100%" }}
                >
                  {folder.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {formatDate(folder.createdAt)}
                </Typography>
                {isGlobalSearch && folder.parent && (
                  <Typography 
                    variant="caption" 
                    color="text.secondary" 
                    sx={{ 
                      fontSize: '0.7rem',
                      textAlign: 'center',
                      backgroundColor: 'grey.100',
                      px: 1,
                      py: 0.25,
                      borderRadius: 1,
                      mt: 0.5
                    }}
                  >
                    📁 {folder.parent.name}
                  </Typography>
                )}
                {folder.tags && folder.tags.length > 0 && (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 1, justifyContent: "center" }}>
                    {folder.tags.slice(0, 2).map((folderTag) => {
                      const tag = folderTag.tag || folderTag;
                      return (
                        <TagChip
                          key={tag.id}
                          tag={tag}
                          size="small"
                          clickable={false}
                        />
                      );
                    })}
                    {folder.tags.length > 2 && (
                      <Chip
                        label={`+${folder.tags.length - 2}`}
                        size="small"
                        sx={{
                          fontSize: '0.7rem',
                          height: 20,
                          backgroundColor: 'grey.200',
                          color: 'grey.700'
                        }}
                      />
                    )}
                  </Box>
                )}
              </Box>
              <Divider />
              <Box sx={{ display: "flex", justifyContent: "center", p: 1 }}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFolderMenuOpen(e, folder);
                  }}
                >
                  <MoreVertIcon fontSize="small" />
                </IconButton>
              </Box>
            </Paper>
          </Grid>
        ))}

        {sortedFiles.map((file) => (
          <Grid item xs={6} sm={4} md={3} lg={2} key={file.id}>
            <Paper
              elevation={0}
              sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                overflow: "hidden",
                transition: "all 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                },
              }}
            >
              <Box
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => handleFileClick(file)}
              >
                {getFileIcon(file.mimeType)}
                <Typography
                  variant="subtitle2"
                  align="center"
                  noWrap
                  sx={{ width: "100%", mt: 1 }}
                >
                  {file.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {formatFileSize(file.size)}
                </Typography>
                {isGlobalSearch && file.folder && (
                  <Typography 
                    variant="caption" 
                    color="text.secondary" 
                    sx={{ 
                      fontSize: '0.7rem',
                      textAlign: 'center',
                      backgroundColor: 'grey.100',
                      px: 1,
                      py: 0.25,
                      borderRadius: 1,
                      mt: 0.5
                    }}
                  >
                    📁 {file.folder.name}
                  </Typography>
                )}
                {file.isPublic && (
                  <Chip
                    icon={<PublicIcon fontSize="small" />}
                    label="Público"
                    size="small"
                    color="primary"
                    variant="outlined"
                    sx={{ mt: 1, height: 24 }}
                  />
                )}
              </Box>
              <Divider />
              <Box sx={{ display: "flex", justifyContent: "center", p: 1 }}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMenuOpen(e, file);
                  }}
                >
                  <MoreVertIcon fontSize="small" />
                </IconButton>
              </Box>
            </Paper>
          </Grid>
        ))}

        {sortedFolders.length === 0 && sortedFiles.length === 0 && (
          <Grid item xs={12}>
            <Box
              sx={{
                p: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "background.paper",
                borderRadius: 2,
                border: "1px dashed",
                borderColor: "divider",
              }}
            >
              <Typography variant="h6" color="text.secondary" gutterBottom>
                Nenhum item encontrado
              </Typography>
              <Typography variant="body2" color="text.secondary" align="center">
                {searchTerm
                  ? "Tente uma pesquisa diferente ou limpe o filtro"
                  : "Nenhum item encontrado"}
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    );
  };

  const renderListView = () => {
    let currentFiles, currentFolders;
    
    if (isGlobalSearch && searchResults.folders && searchResults.files) {
      currentFiles = searchResults.files;
      currentFolders = searchResults.folders;
    } else {
      currentFiles = files;
      currentFolders = folders;
    }

    const filteredFolders = filterItems(currentFolders);
    const filteredFiles = filterItems(currentFiles);

    const sortedFolders = sortItems(filteredFolders);
    const sortedFiles = sortItems(filteredFiles);

    return (
      <TableContainer component={Paper} elevation={0}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "grey.50" }}>
              <TableCell width="40%">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSortChange("name")}
                >
                  Nome
                  {sortField === "name" &&
                    (sortDirection === "asc" ? (
                      <ArrowUpwardIcon fontSize="small" sx={{ ml: 0.5 }} />
                    ) : (
                      <ArrowDownwardIcon fontSize="small" sx={{ ml: 0.5 }} />
                    ))}
                </Box>
              </TableCell>
              <TableCell width="15%">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSortChange("size")}
                >
                  Tamanho
                  {sortField === "size" &&
                    (sortDirection === "asc" ? (
                      <ArrowUpwardIcon fontSize="small" sx={{ ml: 0.5 }} />
                    ) : (
                      <ArrowDownwardIcon fontSize="small" sx={{ ml: 0.5 }} />
                    ))}
                </Box>
              </TableCell>
              <TableCell width="20%">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSortChange("updatedAt")}
                >
                  Modificado
                  {sortField === "updatedAt" &&
                    (sortDirection === "asc" ? (
                      <ArrowUpwardIcon fontSize="small" sx={{ ml: 0.5 }} />
                    ) : (
                      <ArrowDownwardIcon fontSize="small" sx={{ ml: 0.5 }} />
                    ))}
                </Box>
              </TableCell>
              <TableCell width="15%">Tipo</TableCell>
              <TableCell width="10%" align="center">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedFolders.map((folder) => (
              <TableRow
                key={folder.id}
                hover
                onClick={() => handleFolderClick(folder)}
                sx={{ cursor: "pointer" }}
              >
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", alignItems: "flex-start" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <FolderIcon color="primary" sx={{ mr: 1 }} />
                      <Typography variant="body2">{folder.name}</Typography>
                    </Box>
                    {isGlobalSearch && folder.parent && (
                      <Typography 
                        variant="caption" 
                        color="text.secondary" 
                        sx={{ 
                          fontSize: '0.7rem',
                          backgroundColor: 'grey.100',
                          px: 1,
                          py: 0.25,
                          borderRadius: 1,
                          mt: 0.5
                        }}
                      >
                        📁 Em: {folder.parent.name}
                      </Typography>
                    )}
                    {folder.tags && folder.tags.length > 0 && (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 1 }}>
                        {folder.tags.slice(0, 3).map((folderTag) => {
                          const tag = folderTag.tag || folderTag;
                          return (
                            <TagChip
                              key={tag.id}
                              tag={tag}
                              size="small"
                              clickable={false}
                            />
                          );
                        })}
                        {folder.tags.length > 3 && (
                          <Chip
                            label={`+${folder.tags.length - 3}`}
                            size="small"
                            sx={{
                              fontSize: '0.7rem',
                              height: 20,
                              backgroundColor: 'grey.200',
                              color: 'grey.700'
                            }}
                          />
                        )}
                      </Box>
                    )}
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">-</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {formatDate(folder.updatedAt || folder.createdAt)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">Pasta</Typography>
                </TableCell>
                <TableCell align="center">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFolderMenuOpen(e, folder);
                    }}
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {sortedFiles.map((file) => (
              <TableRow
                key={file.id}
                hover
                onClick={() => handleFileClick(file)}
                sx={{ cursor: "pointer" }}
              >
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", alignItems: "flex-start" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {getFileIcon(file.mimeType)}
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        {file.name}
                      </Typography>
                    </Box>
                    {isGlobalSearch && file.folder && (
                      <Typography 
                        variant="caption" 
                        color="text.secondary" 
                        sx={{ 
                          fontSize: '0.7rem',
                          backgroundColor: 'grey.100',
                          px: 1,
                          py: 0.25,
                          borderRadius: 1,
                          mt: 0.5
                        }}
                      >
                        📁 Em: {file.folder.name}
                      </Typography>
                    )}
                    {file.isPublic && (
                      <Chip
                        icon={<PublicIcon fontSize="small" />}
                        label="Público"
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{ ml: 1, height: 24 }}
                      />
                    )}
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {formatFileSize(file.size)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {formatDate(file.updatedAt)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {file.mimeType.split("/")[1]?.toUpperCase() ||
                      file.mimeType}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMenuOpen(e, file);
                    }}
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {sortedFolders.length === 0 && sortedFiles.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                  <Typography variant="body1" color="text.secondary">
                    {searchTerm
                      ? "Nenhum item encontrado para esta pesquisa"
                      : "Nenhum item nesta pasta. Comece enviando arquivos ou criando pastas."}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  // Função para construir o caminho da pasta de forma iterativa
  const buildFolderPathIterative = async (folderId) => {
    if (!folderId) {
      return [{ id: null, name: "Raiz" }];
    }

    try {
      const response = await folderService.getFolder(folderId);
      const folder = response.data;

      // Iniciar com a pasta atual
      const path = [];
      let currentFolder = folder;

      // Adicionar todas as pastas pais ao caminho (em ordem inversa)
      while (currentFolder) {
        path.unshift({ id: currentFolder.id, name: currentFolder.name });
        currentFolder = currentFolder.parent;
      }

      // Adicionar a raiz no início
      path.unshift({ id: null, name: "Raiz" });

      return path;
    } catch (err) {
      console.error("Erro ao construir caminho da pasta:", err);
      return [{ id: null, name: "Raiz" }];
    }
  };

  const loadFolderTree = async (parentId = null) => {
    try {
      const response = await folderService.getFolders(parentId);
      const folders = response.data || [];
      setFolderTree(folders);
    } catch (err) {
      console.error("Erro ao carregar árvore de pastas:", err);
      setError("Falha ao carregar pastas");
    }
  };

  const handleFolderTreeClick = async (folder) => {
    if (!folder) return;
    setCurrentTreePath((prev) => [...prev, folder]);
    await loadFolderTree(folder.id);
  };

  const handleTreeBack = () => {
    if (currentTreePath.length > 0) {
      const newPath = currentTreePath.slice(0, -1);
      setCurrentTreePath(newPath);
      setSelectedTreeFolder(newPath[newPath.length - 1] || null);
      loadFolderTree(newPath[newPath.length - 1]?.id || null);
    }
  };

  const handleDelete = async () => {
    try {
      await fileService.deleteFile(selectedFile.id);

      // Update files list with the new unified structure
      setFiles((prevFiles) =>
        prevFiles.filter((file) => file.id !== selectedFile.id)
      );

      handleDeleteDialogClose();
    } catch (err) {
      console.error("Erro ao excluir arquivo:", err);
      setError("Falha ao excluir arquivo");
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
              Arquivos e Pastas
            </Typography>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
              {folderPath.map((folder, index) => {
                const isLast = index === folderPath.length - 1;
                return isLast ? (
                  <Typography
                    key={folder.id}
                    color="text.primary"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    {index === 0 && (
                      <HomeIcon fontSize="small" sx={{ mr: 0.5 }} />
                    )}
                    {folder.name}
                  </Typography>
                ) : (
                  <Link
                    key={folder.id}
                    component="button"
                    variant="body2"
                    onClick={() => handleBreadcrumbClick(folder.id)}
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    {index === 0 && (
                      <HomeIcon fontSize="small" sx={{ mr: 0.5 }} />
                    )}
                    {folder.name}
                  </Link>
                );
              })}
            </Breadcrumbs>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              startIcon={<CloudUploadIcon />}
              onClick={handleUploadDialogOpen}
            >
              Upload
            </Button>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleBlankMenuOpen}
            >
              Novo documento
            </Button>
            <Menu
              anchorEl={blankMenuAnchor}
              open={Boolean(blankMenuAnchor)}
              onClose={handleBlankMenuClose}
            >
              <MenuItem onClick={() => handleBlankTypeSelect("word")}>
                <ListItemIcon>
                  <DescriptionIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Documento Word" />
              </MenuItem>
              <MenuItem onClick={() => handleBlankTypeSelect("excel")}>
                <ListItemIcon>
                  <TableChartIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Planilha Excel" />
              </MenuItem>
            </Menu>
            <Button
              variant="outlined"
              startIcon={<CreateNewFolderIcon />}
              onClick={handleCreateFolderDialogOpen}
            >
              Nova Pasta
            </Button>
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(e, newMode) => newMode && setViewMode(newMode)}
              size="small"
            >
              <ToggleButton value="grid">
                <GridViewIcon />
              </ToggleButton>
              <ToggleButton value="list">
                <ViewListIcon />
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Box>
      </Paper>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            borderBottom: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={(e, newValue) => setSelectedTab(newValue)}
            sx={{ minHeight: 0 }}
          >
            <Tab
              label="Arquivos"
              sx={{
                minHeight: 0,
                py: 1,
                px: 2,
                borderRadius: 1,
                "&.Mui-selected": {
                  bgcolor: "primary.light",
                  color: "primary.main",
                },
              }}
            />
          </Tabs>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <TextField
                placeholder="Pesquisar pastas e arquivos globalmente..."
                size="small"
                value={searchTerm}
                onChange={(e) => handleSearchChange(e.target.value)}
                onKeyPress={handleSearchKeyPress}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  sx: { borderRadius: 2 },
                }}
                sx={{ width: 300 }}
                helperText={isGlobalSearch && searchResults.totalResults !== undefined ? 
                  `${searchResults.totalResults} resultado(s) encontrado(s)` : null}
              />
              <Button
                variant="contained"
                size="small"
                onClick={handleSearchClick}
                disabled={isSearching || searchTerm.trim().length < 2}
                startIcon={isSearching ? <CircularProgress size={16} /> : <SearchIcon />}
                sx={{ minWidth: 'auto', px: 2 }}
              >
                {isSearching ? 'Buscando...' : 'Buscar'}
              </Button>
              {isGlobalSearch && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    setSearchTerm('');
                    setIsGlobalSearch(false);
                    setSearchResults([]);
                  }}
                  sx={{ minWidth: 'auto', px: 2 }}
                >
                  Limpar
                </Button>
              )}
            </Box>
          </Box>
        </Box>

        <Box sx={{ p: 2, bgcolor: "background.paper" }}>
          {viewMode === "grid" ? renderGridView() : renderListView()}
        </Box>
      </Paper>

      {/* File Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {isAdmin && (
          <MenuItem onClick={handleDeleteDialogOpen}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            Excluir
          </MenuItem>
        )}
        <MenuItem onClick={handleMoveFileDialogOpen}>
          <ListItemIcon>
            <DriveFileMoveIcon fontSize="small" />
          </ListItemIcon>
          Mover
        </MenuItem>
        <MenuItem onClick={handleRenameFileDialogOpen}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          Renomear
        </MenuItem>
      </Menu>

      {/* Rename File Dialog */}
      <Dialog
        open={renameFileDialogOpen}
        onClose={handleRenameFileDialogClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Renomear Arquivo</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nome do arquivo"
            fullWidth
            value={newFileName}
            onChange={(e) => setNewFileName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleRenameFile();
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRenameFileDialogClose}>Cancelar</Button>
          <Button onClick={handleRenameFile} variant="contained">
            Renomear
          </Button>
        </DialogActions>
      </Dialog>

      {/* Folder Menu */}
      <Menu
        anchorEl={folderAnchorEl}
        open={Boolean(folderAnchorEl)}
        onClose={handleFolderMenuClose}
      >
        {isAdmin && (
          <>
            <MenuItem onClick={handleShareDialogOpen}>
              <ListItemIcon>
                <ShareIcon fontSize="small" />
              </ListItemIcon>
              Compartilhar
            </MenuItem>
            <MenuItem onClick={handleDeleteDialogOpen}>
              <ListItemIcon>
                <DeleteIcon fontSize="small" />
              </ListItemIcon>
              Excluir
            </MenuItem>
          </>
        )}
        <MenuItem onClick={handleRenameFolderDialogOpen}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          Renomear
        </MenuItem>
        <MenuItem onClick={handleFolderTagsDialogOpen}>
          <ListItemIcon>
            <LabelIcon fontSize="small" />
          </ListItemIcon>
          Editar Tags
        </MenuItem>
        <MenuItem onClick={handleMoveFolderDialogOpen}>
          <ListItemIcon>
            <DriveFileMoveIcon fontSize="small" />
          </ListItemIcon>
          Mover
        </MenuItem>
      </Menu>

      {/* Blank Document Dialog */}
      <Dialog
        open={blankDialogOpen}
        onClose={() => setBlankDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          {blankType === "word" ? "Novo documento Word" : "Nova planilha Excel"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nome do arquivo"
            fullWidth
            value={blankName}
            onChange={(e) => setBlankName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleBlankCreate();
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setBlankDialogOpen(false)}
            disabled={blankLoading}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleBlankCreate}
            variant="contained"
            disabled={blankLoading || !blankName.trim()}
          >
            {blankLoading ? "Criando..." : "Criar e abrir"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Upload Dialog */}
      <Dialog
        open={uploadDialogOpen}
        onClose={handleUploadDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Enviar Arquivo</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Selecione um arquivo para enviar ao seu armazenamento.
          </DialogContentText>

          {uploadError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {uploadError}
            </Alert>
          )}

          <Box
            {...getRootProps()}
            sx={{
              border: "2px dashed",
              borderColor: "primary.main",
              borderRadius: 2,
              p: 3,
              textAlign: "center",
              mb: 2,
              cursor: "pointer",
              bgcolor: "rgba(0, 0, 0, 0.02)",
              "&:hover": {
                bgcolor: "rgba(0, 0, 0, 0.05)",
              },
            }}
          >
            <input {...getInputProps()} />
            <CloudUploadIcon
              sx={{ fontSize: 48, color: "primary.main", mb: 1 }}
            />
            {acceptedFiles.length > 0 ? (
              <Box sx={{ width: "100%" }}>
                <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
                  {acceptedFiles.length} arquivo(s) selecionado(s)
                </Typography>
                <Box sx={{ maxHeight: 150, overflow: "auto", textAlign: "left" }}>
                  {acceptedFiles.map((f, i) => (
                    <Typography key={i} variant="body2" color="text.secondary" noWrap>
                      • {f.name} ({(f.size / 1024).toFixed(1)} KB)
                    </Typography>
                  ))}
                </Box>
              </Box>
            ) : (
              <Box>
                <Typography variant="body1" gutterBottom>
                  Arraste e solte arquivos aqui
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Pode selecionar múltiplos arquivos
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    open();
                  }}
                >
                  ou clique para selecionar
                </Button>
              </Box>
            )}
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={isPublic}
                onChange={(e) => setIsPublic(e.target.checked)}
              />
            }
            label="Tornar este arquivo público"
          />

          {uploadProgress > 0 && uploadProgress < 100 && (
            <Box sx={{ mt: 2 }}>
              <CircularProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ mt: 1 }}>
                Enviando... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleUploadDialogClose}>Cancelar</Button>
          <Button
            onClick={handleUpload}
            variant="contained"
            disabled={acceptedFiles.length === 0 || uploadProgress > 0}
            startIcon={<CloudUploadIcon />}
          >
            Enviar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleDeleteDialogClose}>
        <DialogTitle>
          Excluir {selectedFolder ? "Pasta" : "Arquivo"}
        </DialogTitle>
        <DialogContent>
          {!isAdmin ? (
            <Alert severity="error">
              Apenas administradores podem excluir{" "}
              {selectedFolder ? "pastas" : "arquivos"}.
            </Alert>
          ) : (
            <DialogContentText>
              Tem certeza que deseja excluir{" "}
              {selectedFolder ? "esta pasta" : "este arquivo"}? Esta ação não
              pode ser desfeita.
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>Cancelar</Button>
          {isAdmin && (
            <Button
              onClick={selectedFolder ? handleDeleteFolder : handleDelete}
              color="error"
            >
              Excluir
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Create Folder Dialog */}
      <Dialog
        open={createFolderDialogOpen}
        onClose={handleCreateFolderDialogClose}
      >
        <DialogTitle>Nova Pasta</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Digite o nome da nova pasta.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Nome da Pasta"
            type="text"
            fullWidth
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCreateFolderDialogClose}>Cancelar</Button>
          <Button
            onClick={handleCreateFolder}
            variant="contained"
            disabled={!newFolderName.trim()}
          >
            Criar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Rename Folder Dialog */}
      <Dialog
        open={renameFolderDialogOpen}
        onClose={handleRenameFolderDialogClose}
      >
        <DialogTitle>Renomear Pasta</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Digite o novo nome para a pasta.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Nome da Pasta"
            type="text"
            fullWidth
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRenameFolderDialogClose}>Cancelar</Button>
          <Button
            onClick={handleRenameFolder}
            variant="contained"
            disabled={!newFolderName.trim()}
          >
            Renomear
          </Button>
        </DialogActions>
      </Dialog>

      {/* Move Folder Dialog */}
      <Dialog
        open={moveFolderDialogOpen}
        onClose={handleMoveFolderDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Mover "{selectedFolder?.name}"</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Navegue até a pasta de destino e clique em "Mover para cá".
          </DialogContentText>

          {/* Breadcrumb da navegação */}
          <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            <Button
              size="small"
              startIcon={<HomeIcon />}
              onClick={() => {
                setCurrentTreePath([]);
                loadFolderTree();
              }}
              disabled={currentTreePath.length === 0}
            >
              Raiz
            </Button>
            {currentTreePath.map((folder, index) => (
              <React.Fragment key={folder.id}>
                <Typography>/</Typography>
                <Button
                  size="small"
                  onClick={() => {
                    const newPath = currentTreePath.slice(0, index + 1);
                    setCurrentTreePath(newPath);
                    loadFolderTree(folder.id);
                  }}
                >
                  {folder.name}
                </Button>
              </React.Fragment>
            ))}
          </Box>

          {/* Lista de pastas - click navega pra dentro */}
          <List sx={{ maxHeight: 300, overflow: "auto", border: 1, borderColor: "divider", borderRadius: 1 }}>
            {folderTree.filter((f) => f.id !== selectedFolder?.id).length === 0 ? (
              <ListItem>
                <ListItemText
                  primary="Sem subpastas"
                  secondary="Clique em 'Mover para cá' para mover para esta localização"
                />
              </ListItem>
            ) : (
              folderTree
                .filter((f) => f.id !== selectedFolder?.id)
                .map((folder) => (
                  <ListItem key={folder.id} disablePadding>
                    <ListItemButton onClick={() => handleFolderTreeClick(folder)}>
                      <ListItemIcon>
                        <FolderIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText primary={folder.name} />
                    </ListItemButton>
                  </ListItem>
                ))
            )}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleMoveFolderDialogClose}>Cancelar</Button>
          <Button onClick={handleMoveFolder} variant="contained">
            Mover para{" "}
            {currentTreePath.length === 0
              ? "Raiz"
              : currentTreePath[currentTreePath.length - 1].name}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Move File Dialog */}
      <Dialog
        open={moveFileDialogOpen}
        onClose={handleMoveFileDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Mover "{selectedFile?.name}"</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Navegue até a pasta de destino e clique em "Mover para cá".
          </DialogContentText>

          <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            <Button
              size="small"
              startIcon={<HomeIcon />}
              onClick={() => {
                setCurrentTreePath([]);
                loadFolderTree();
              }}
              disabled={currentTreePath.length === 0}
            >
              Raiz
            </Button>
            {currentTreePath.map((folder, index) => (
              <React.Fragment key={folder.id}>
                <Typography>/</Typography>
                <Button
                  size="small"
                  onClick={() => {
                    const newPath = currentTreePath.slice(0, index + 1);
                    setCurrentTreePath(newPath);
                    loadFolderTree(folder.id);
                  }}
                >
                  {folder.name}
                </Button>
              </React.Fragment>
            ))}
          </Box>

          <List sx={{ maxHeight: 300, overflow: "auto", border: 1, borderColor: "divider", borderRadius: 1 }}>
            {folderTree.length === 0 ? (
              <ListItem>
                <ListItemText
                  primary="Sem subpastas"
                  secondary="Clique em 'Mover para cá' para mover para esta localização"
                />
              </ListItem>
            ) : (
              folderTree.map((folder) => (
                <ListItem key={folder.id} disablePadding>
                  <ListItemButton onClick={() => handleFolderTreeClick(folder)}>
                    <ListItemIcon>
                      <FolderIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={folder.name} />
                  </ListItemButton>
                </ListItem>
              ))
            )}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleMoveFileDialogClose}>Cancelar</Button>
          <Button onClick={handleMoveFile} variant="contained">
            Mover para{" "}
            {currentTreePath.length === 0
              ? "Raiz"
              : currentTreePath[currentTreePath.length - 1].name}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Share Folder Dialog */}
      <Dialog
        open={shareFolderDialogOpen}
        onClose={handleShareFolderDialogClose}
      >
        <DialogTitle>Compartilhar Pasta</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Selecione um grupo para compartilhar esta pasta e defina o nível de
            acesso.
          </DialogContentText>

          <TextField
            select
            label="Grupo"
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
          >
            {groups.map((group) => (
              <MenuItem key={group.id} value={group.id}>
                {group.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Nível de Acesso"
            value={accessLevel}
            onChange={(e) => setAccessLevel(e.target.value)}
            fullWidth
          >
            <MenuItem value="READ">Leitura</MenuItem>
            <MenuItem value="WRITE">Escrita</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleShareFolderDialogClose}>Cancelar</Button>
          <Button
            onClick={handleShareFolder}
            variant="contained"
            disabled={!selectedGroup}
          >
            Compartilhar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Share Dialog */}
      <SharePermissionsDialog
        open={shareDialogOpen}
        onClose={handleShareDialogClose}
        itemType={selectedFolder ? "folder" : "file"}
        itemId={
          selectedFolder
            ? selectedFolder.id
            : selectedFile
              ? selectedFile.id
              : ""
        }
        itemName={
          selectedFolder
            ? selectedFolder.name
            : selectedFile
              ? selectedFile.name
              : ""
        }
      />

      {/* Edit Folder Tags Dialog */}
      {selectedFolder && (
        <EditFolderTagsDialog
          open={folderTagsDialogOpen}
          onClose={handleFolderTagsDialogClose}
          folder={selectedFolder}
          onSave={handleUpdateFolderTags}
        />
      )}
    </Box>
  );
};

export default Dashboard;
